module.exports = __webpack_public_path__ + "img/989784_665542_BFECE5_6D644C-256px.7026b05f.png";